import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { IssueDispositionType } from '../../DispositionTypesContext/types'
import { useRemoveIssueDispositionTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useDispositionTypesContext } from '../../DispositionTypesContext'

export function useRemove(): RemoveRowActionOptions<IssueDispositionType> {
  const { refetch } = useDispositionTypesContext()
  const [remove] = useRemoveIssueDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveIssueDispositionType: {
        dispositionType: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreIssueDispositionType,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
    disabled: ({ issues }) =>
      !!issues.length && {
        message:
          'Issue Disposition Types cannot be deleted if they are associated with one or more Issues',
      },
  }
}
